module.exports = __webpack_public_path__ + "img/homepage-doodle.c730ec15.png";